var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.375C14.8647 1.375 15.2144 1.51987 15.4723 1.77773C15.7301 2.03559 15.875 2.38533 15.875 2.75V17.5381C15.875 17.5381 14.5 15.125 9 15.125C3.5 15.125 2.125 17.5381 2.125 17.5381V2.75C2.125 2.38533 2.26987 2.03559 2.52773 1.77773C2.78559 1.51987 3.13533 1.375 3.5 1.375H14.5ZM3.5 0C2.77065 0 2.07118 0.289731 1.55546 0.805456C1.03973 1.32118 0.75 2.02065 0.75 2.75V19.25C0.75 19.9793 1.03973 20.6788 1.55546 21.1945C2.07118 21.7103 2.77065 22 3.5 22H14.5C15.2293 22 15.9288 21.7103 16.4445 21.1945C16.9603 20.6788 17.25 19.9793 17.25 19.25V2.75C17.25 2.02065 16.9603 1.32118 16.4445 0.805456C15.9288 0.289731 15.2293 0 14.5 0L3.5 0Z",
    fill: "#FDF7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.75C9.5417 13.75 10.0781 13.6433 10.5786 13.436C11.079 13.2287 11.5338 12.9249 11.9168 12.5418C12.2999 12.1588 12.6037 11.704 12.811 11.2036C13.0183 10.7031 13.125 10.1667 13.125 9.625C13.125 9.0833 13.0183 8.5469 12.811 8.04643C12.6037 7.54596 12.2999 7.09123 11.9168 6.70818C11.5338 6.32514 11.079 6.0213 10.5786 5.814C10.0781 5.6067 9.5417 5.5 9 5.5C7.90598 5.5 6.85677 5.9346 6.08318 6.70818C5.3096 7.48177 4.875 8.53098 4.875 9.625C4.875 10.719 5.3096 11.7682 6.08318 12.5418C6.85677 13.3154 7.90598 13.75 9 13.75Z",
    fill: "#FDF7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.0ea85966c01b1d8bbfcd21b6d0a6c0b2.svg";
export { ForwardRef as ReactComponent };